module.exports = "<p>\r\n  Welcome to the Waivers and Favours application, please sign in.\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/welcome-page/welcome-page.component.html
// module id = ./src/app/welcome-page/welcome-page.component.html
// module chunks = main